import { render, staticRenderFns } from "./win.vue?vue&type=template&id=c6fccbe6&scoped=true&"
import script from "./win.vue?vue&type=script&lang=js&"
export * from "./win.vue?vue&type=script&lang=js&"
import style0 from "./win.vue?vue&type=style&index=0&id=c6fccbe6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fccbe6",
  null
  
)

export default component.exports